import { createAction } from '@reduxjs/toolkit';
import { ManageCourseAccessModalProps } from 'redux/schemas/app/course-access-modal';

export const setCourseAccessModalProps = createAction<ManageCourseAccessModalProps>('SET_COURSE_ACCESS_MODAL_PROPS');
export const resetCourseAccessModalProps = createAction('RESET_COURSE_ACCESS_MODAL_PROPS');
